<template>
  <div class="page-template" v-loading="loading">
<!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="生鲜出品率报表" name="produce">
        <search-form-template
          :searchOptions="produceSearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template
          ref="produce"
          :tableOptions="produceTable"
        >
        </table-template>
      </el-tab-pane>
      <el-tab-pane label="生鲜大类报表" name="category">
        <search-form-template
          :searchOptions="categorySearchOptions"
          @searchSubmit="searchSubmit"
          :toolConfig="toolConfig"
        ></search-form-template>
        <table-template
          ref="category"
          :tableOptions="categoryTable"
        ></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from "@/components/template/searchFormTemplate";
  import tableTemplate from "@/components/template/tableTemplate";
  import api from "@/config/api";
  import userPower from "@/mixin/userPower";

  export default {
  mixins: [userPower],
  name: "RoleManager",
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: "produce",
      loading: false,
      treeConfig: {
        id: "menuTree",
        showCheckbox: true,
        data: [],
        nodeKey: "id",
        defaultProps: {
          children: "children",
          label: "name",
        },
        request: {
          api: api.system.rolePrivilege,
          param: { roleId: "" },
        },
      },

      // 更多功能
      toolConfig: [
        {
          label: "打印",
          code: "print",
        },
        {
          label: "导出",
          code: "export",
        },
      ],

      produceSearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "cashierSttName",
            isFuzzy: true,
            placeholder: "门店名称/ 姓名",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            change: this.getProduceCashierChange,
            url: api.system.seStore,
          },
          {
            label: "收银员",
            type: "select",
            prop: "cashierId",
            data: [],
            span: 12,
            //url: api.system.account,
          },
          {
            label: "方式",
            prop: "zeroType",
            type: "radio",
            span: 12,
            data: [{ label: "包含抹零金额", value: 20 }],
          },
        ],
      },

      categorySearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "cashierReltName",
            isFuzzy: true,
            placeholder: "收银员/收银员编码",
          },
        ],
        complex: [
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "dateTimeRangeButton",
            dateType: "datetime",
            span: 24,
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            span: 12,
            change: this.getCategoryCashierChange,
            url: api.system.seStore,
          },
          {
            label: "收银员",
            type: "select",
            prop: "cashierId",
            data: [],
            span: 12,
            //url: api.system.account,
          },
          {
            label: "方式",
            prop: "zeroType",
            type: "radio",
            span: 12,
            data: [{ label: "包含抹零金额", value: 20 }],
          },
        ],
      },

      produceTable: {
        indexShow: true, //是否显示索引
        param: { zeroType: 10 }, // 不包含抹零
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "180",
            align: "center",
          },
          {
            label: "门店编码",
            prop: "storeCode",
            width: "150",
            align: "center",
          },
          {
            label: "收银员编码",
            prop: "cashierCode",
            width: "150",
            align: "center",
          },
          {
            label: "收银员名称",
            prop: "cashierName",
            width: "150",
            align: "center",
          },
          {
            label: "现金",
            prop: "cashierMoney",
            width: "100",
            align: "center",
          },
          {
            label: "店播",
            prop: "dbyMoney",
            width: "100",
            align: "center",
          },
          {
            label: "银行卡",
            prop: "bankCardMoney",
            width: "100",
            align: "center",
          },
          {
            label: "微信",
            prop: "weChatMoney",
            width: "100",
            align: "center",
          },
          {
            label: "支付宝",
            prop: "aliMoney",
            width: "100",
            align: "center",
          },
          {
            label: "会员",
            prop: "vipMoney",
            width: "100",
            align: "center",
          },
          {
            label: "小程序",
            prop: "programMoney",
            width: "100",
            align: "center",
          },
          {
            label: "其他支付",
            prop: "otherMoney",
            width: "100",
            align: "center",
          },
          {
            label: "组合支付",
            prop: "combinationMoney",
            width: "100",
            align: "center",
          },
          {
            label: "合计(不含找零)",
            prop: "totalMoney",
            width: "150",
            align: "center",
          },
        ],
        url: api.retail.cashierDayStatement,
      },

      categoryTable: {
        indexShow: true, //是否显示索引
        param: { zeroType: 10 }, // 不包含抹零
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "门店名称",
            prop: "storeName",
            width: "180",
            align: "center",
          },
          {
            label: "门店编码",
            prop: "storeCode",
            width: "150",
            align: "center",
          },
          {
            label: "收银员编码",
            prop: "cashierCode",
            width: "150",
            align: "center",
          },
          {
            label: "收银员名称",
            prop: "cashierName",
            width: "150",
            align: "center",
          },
          {
            label: "交易方式",
            prop: "orderType",
            width: "150",
            align: "center",
            enumData: this.$utils.getCacheStatus("soBillOrder.orderType"),
          },
          {
            label: "金额",
            prop: "amountReceived",
            width: "150",
            align: "center",
          },
        ],
        url: api.retail.cashierReconciliation,
      },
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.produceSearchOptions.complex);
    this.setStore(this.categorySearchOptions.complex);
    this.getCashier();
  },
  mounted() {},
  methods: {
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    tabChange() {
      this.$refs[this.activeTab].operationSuccess();
    },

    getCashier() {
      let userInfo = this.$utils.getSysUser();
      if (userInfo.type === 20) {
        this.$axios.fetchPost(api.system.type + '/list', {type: 40}).then(data => {
          if (data.code === 200) {
            this.produceSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
            this.categorySearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      }
    },
    getProduceCashierChange(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
        if (data.code === 200) {
          this.produceSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      })
    },
    getCategoryCashierChange(form) {
      form.cashierId = '';
      this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
        if (data.code === 200) {
          this.categorySearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
        }
      })
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/weigh/query/Produce.vue